// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file call/call_requests.proto (package com.gem.vcs.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type {
  CallPermission_AccessType,
  CallPermission_RequestStatus,
  CallPermissions,
  PersonalizedCallPermissions,
} from './call_model_pb';
import { file_call_call_model } from './call_model_pb';

/**
 * Describes the file call/call_requests.proto.
 */
export const file_call_call_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_call_call_model]
  );

/**
 * @generated from message com.gem.vcs.contract.JoinToCallRequest
 */
export type JoinToCallRequest = Message<'com.gem.vcs.contract.JoinToCallRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;
};

/**
 * Describes the message com.gem.vcs.contract.JoinToCallRequest.
 * Use `create(JoinToCallRequestSchema)` to create a new message.
 */
export const JoinToCallRequestSchema: GenMessage<JoinToCallRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 0);

/**
 * @generated from message com.gem.vcs.contract.FinishForAllRequest
 */
export type FinishForAllRequest = Message<'com.gem.vcs.contract.FinishForAllRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;
};

/**
 * Describes the message com.gem.vcs.contract.FinishForAllRequest.
 * Use `create(FinishForAllRequestSchema)` to create a new message.
 */
export const FinishForAllRequestSchema: GenMessage<FinishForAllRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 1);

/**
 * @generated from message com.gem.vcs.contract.KickMemberRequest
 */
export type KickMemberRequest = Message<'com.gem.vcs.contract.KickMemberRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;

  /**
   * @generated from field: int64 targetMemberId = 2;
   */
  targetMemberId: bigint;

  /**
   * @generated from field: optional string targetDeviceId = 3;
   */
  targetDeviceId?: string;
};

/**
 * Describes the message com.gem.vcs.contract.KickMemberRequest.
 * Use `create(KickMemberRequestSchema)` to create a new message.
 */
export const KickMemberRequestSchema: GenMessage<KickMemberRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 2);

/**
 * @generated from message com.gem.vcs.contract.ForceMuteRequest
 */
export type ForceMuteRequest = Message<'com.gem.vcs.contract.ForceMuteRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;

  /**
   * @generated from field: int64 targetMemberId = 2;
   */
  targetMemberId: bigint;

  /**
   * @generated from field: optional string targetDeviceId = 3;
   */
  targetDeviceId?: string;
};

/**
 * Describes the message com.gem.vcs.contract.ForceMuteRequest.
 * Use `create(ForceMuteRequestSchema)` to create a new message.
 */
export const ForceMuteRequestSchema: GenMessage<ForceMuteRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 3);

/**
 * @generated from message com.gem.vcs.contract.GetCallMembersRequest
 */
export type GetCallMembersRequest = Message<'com.gem.vcs.contract.GetCallMembersRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message com.gem.vcs.contract.GetCallMembersRequest.
 * Use `create(GetCallMembersRequestSchema)` to create a new message.
 */
export const GetCallMembersRequestSchema: GenMessage<GetCallMembersRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 4);

/**
 * @generated from message com.gem.vcs.contract.GetCallMembersByCameraOrScreenIdsRequest
 */
export type GetCallMembersByCameraOrScreenIdsRequest =
  Message<'com.gem.vcs.contract.GetCallMembersByCameraOrScreenIdsRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: repeated string ids = 2;
     */
    ids: string[];
  };

/**
 * Describes the message com.gem.vcs.contract.GetCallMembersByCameraOrScreenIdsRequest.
 * Use `create(GetCallMembersByCameraOrScreenIdsRequestSchema)` to create a new message.
 */
export const GetCallMembersByCameraOrScreenIdsRequestSchema: GenMessage<GetCallMembersByCameraOrScreenIdsRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 5);

/**
 * @generated from message com.gem.vcs.contract.GetCallMembersByIdsRequest
 */
export type GetCallMembersByIdsRequest =
  Message<'com.gem.vcs.contract.GetCallMembersByIdsRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: repeated int64 ids = 2;
     */
    ids: bigint[];
  };

/**
 * Describes the message com.gem.vcs.contract.GetCallMembersByIdsRequest.
 * Use `create(GetCallMembersByIdsRequestSchema)` to create a new message.
 */
export const GetCallMembersByIdsRequestSchema: GenMessage<GetCallMembersByIdsRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 6);

/**
 * @generated from message com.gem.vcs.contract.GetCallPermissionsRequest
 */
export type GetCallPermissionsRequest =
  Message<'com.gem.vcs.contract.GetCallPermissionsRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;
  };

/**
 * Describes the message com.gem.vcs.contract.GetCallPermissionsRequest.
 * Use `create(GetCallPermissionsRequestSchema)` to create a new message.
 */
export const GetCallPermissionsRequestSchema: GenMessage<GetCallPermissionsRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 7);

/**
 * @generated from message com.gem.vcs.contract.SetCallPermissionsForAllRequest
 */
export type SetCallPermissionsForAllRequest =
  Message<'com.gem.vcs.contract.SetCallPermissionsForAllRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: com.gem.vcs.contract.CallPermissions default = 2;
     */
    default?: CallPermissions;
  };

/**
 * Describes the message com.gem.vcs.contract.SetCallPermissionsForAllRequest.
 * Use `create(SetCallPermissionsForAllRequestSchema)` to create a new message.
 */
export const SetCallPermissionsForAllRequestSchema: GenMessage<SetCallPermissionsForAllRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 8);

/**
 * @generated from message com.gem.vcs.contract.SetCallPermissionsForMemberRequest
 */
export type SetCallPermissionsForMemberRequest =
  Message<'com.gem.vcs.contract.SetCallPermissionsForMemberRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: int64 memberId = 2;
     */
    memberId: bigint;

    /**
     * @generated from field: com.gem.vcs.contract.PersonalizedCallPermissions personalized = 3;
     */
    personalized?: PersonalizedCallPermissions;
  };

/**
 * Describes the message com.gem.vcs.contract.SetCallPermissionsForMemberRequest.
 * Use `create(SetCallPermissionsForMemberRequestSchema)` to create a new message.
 */
export const SetCallPermissionsForMemberRequestSchema: GenMessage<SetCallPermissionsForMemberRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 9);

/**
 * @generated from message com.gem.vcs.contract.ClearPermissionsForMemberRequest
 */
export type ClearPermissionsForMemberRequest =
  Message<'com.gem.vcs.contract.ClearPermissionsForMemberRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: int64 memberId = 2;
     */
    memberId: bigint;
  };

/**
 * Describes the message com.gem.vcs.contract.ClearPermissionsForMemberRequest.
 * Use `create(ClearPermissionsForMemberRequestSchema)` to create a new message.
 */
export const ClearPermissionsForMemberRequestSchema: GenMessage<ClearPermissionsForMemberRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 10);

/**
 * @generated from message com.gem.vcs.contract.CreatePermissionRequestRequest
 */
export type CreatePermissionRequestRequest =
  Message<'com.gem.vcs.contract.CreatePermissionRequestRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: com.gem.vcs.contract.CallPermission.AccessType access = 2;
     */
    access: CallPermission_AccessType;
  };

/**
 * Describes the message com.gem.vcs.contract.CreatePermissionRequestRequest.
 * Use `create(CreatePermissionRequestRequestSchema)` to create a new message.
 */
export const CreatePermissionRequestRequestSchema: GenMessage<CreatePermissionRequestRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 11);

/**
 * @generated from message com.gem.vcs.contract.GetPermissionRequestsRequest
 */
export type GetPermissionRequestsRequest =
  Message<'com.gem.vcs.contract.GetPermissionRequestsRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;
  };

/**
 * Describes the message com.gem.vcs.contract.GetPermissionRequestsRequest.
 * Use `create(GetPermissionRequestsRequestSchema)` to create a new message.
 */
export const GetPermissionRequestsRequestSchema: GenMessage<GetPermissionRequestsRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 12);

/**
 * @generated from message com.gem.vcs.contract.UpdatePermissionRequestForMemberRequest
 */
export type UpdatePermissionRequestForMemberRequest =
  Message<'com.gem.vcs.contract.UpdatePermissionRequestForMemberRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: int64 memberId = 2;
     */
    memberId: bigint;

    /**
     * @generated from field: com.gem.vcs.contract.CallPermission.AccessType access = 3;
     */
    access: CallPermission_AccessType;

    /**
     * @generated from field: com.gem.vcs.contract.CallPermission.RequestStatus status = 4;
     */
    status: CallPermission_RequestStatus;
  };

/**
 * Describes the message com.gem.vcs.contract.UpdatePermissionRequestForMemberRequest.
 * Use `create(UpdatePermissionRequestForMemberRequestSchema)` to create a new message.
 */
export const UpdatePermissionRequestForMemberRequestSchema: GenMessage<UpdatePermissionRequestForMemberRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 13);

/**
 * @generated from message com.gem.vcs.contract.UpdatePermissionRequestForAllRequest
 */
export type UpdatePermissionRequestForAllRequest =
  Message<'com.gem.vcs.contract.UpdatePermissionRequestForAllRequest'> & {
    /**
     * @generated from field: string channelId = 1;
     */
    channelId: string;

    /**
     * @generated from field: com.gem.vcs.contract.CallPermission.RequestStatus status = 2;
     */
    status: CallPermission_RequestStatus;
  };

/**
 * Describes the message com.gem.vcs.contract.UpdatePermissionRequestForAllRequest.
 * Use `create(UpdatePermissionRequestForAllRequestSchema)` to create a new message.
 */
export const UpdatePermissionRequestForAllRequestSchema: GenMessage<UpdatePermissionRequestForAllRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 14);

/**
 * @generated from message com.gem.vcs.contract.GetCallByIdRequest
 */
export type GetCallByIdRequest = Message<'com.gem.vcs.contract.GetCallByIdRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;
};

/**
 * Describes the message com.gem.vcs.contract.GetCallByIdRequest.
 * Use `create(GetCallByIdRequestSchema)` to create a new message.
 */
export const GetCallByIdRequestSchema: GenMessage<GetCallByIdRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 15);

/**
 * @generated from message com.gem.vcs.contract.GetCallLinkRequest
 */
export type GetCallLinkRequest = Message<'com.gem.vcs.contract.GetCallLinkRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;
};

/**
 * Describes the message com.gem.vcs.contract.GetCallLinkRequest.
 * Use `create(GetCallLinkRequestSchema)` to create a new message.
 */
export const GetCallLinkRequestSchema: GenMessage<GetCallLinkRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 16);

/**
 * @generated from message com.gem.vcs.contract.WaitingRoomAccessRequest
 */
export type WaitingRoomAccessRequest = Message<'com.gem.vcs.contract.WaitingRoomAccessRequest'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;

  /**
   * @generated from field: com.gem.vcs.contract.WaitingRoomAccessRequest.Request request = 2;
   */
  request: WaitingRoomAccessRequest_Request;
};

/**
 * Describes the message com.gem.vcs.contract.WaitingRoomAccessRequest.
 * Use `create(WaitingRoomAccessRequestSchema)` to create a new message.
 */
export const WaitingRoomAccessRequestSchema: GenMessage<WaitingRoomAccessRequest> =
  /*@__PURE__*/
  messageDesc(file_call_call_requests, 17);

/**
 * @generated from enum com.gem.vcs.contract.WaitingRoomAccessRequest.Request
 */
export enum WaitingRoomAccessRequest_Request {
  /**
   * @generated from enum value: ASK_TO_JOIN = 0;
   */
  ASK_TO_JOIN = 0,

  /**
   * @generated from enum value: CANCEL = 1;
   */
  CANCEL = 1,
}

/**
 * Describes the enum com.gem.vcs.contract.WaitingRoomAccessRequest.Request.
 */
export const WaitingRoomAccessRequest_RequestSchema: GenEnum<WaitingRoomAccessRequest_Request> =
  /*@__PURE__*/
  enumDesc(file_call_call_requests, 17, 0);
